// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/aiprod.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-tool-head {
    display: flex;
    flex-direction: column; /* Stack items vertically */
    justify-content: center;
    align-items: center;
    height: 100%; 
    width:100%;
}

.main-tool-div {
    /* height: 250px; */
    min-height: 250px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    width:100%;
    
    
    display: flex;
    flex-direction: column;
}

.logo-tool-box {
    padding-top: 20px;
    /* padding-left: 30px; */
    max-width: 50px;
    /* Adjust as per your logo size */
}

.button-tool-box {
    display: flex;
    gap: 20px;
    margin-right: 70px;
}

.title-tool-box {
    font-size: 4rem;
    font-weight: 600;
    color: white;
    margin-top: 50px;
    margin-left: 0;
    /* margin-left: 20%; */
}

.first-tool-button {
    padding: 10px 15px;
    border-color: black;
    border: none;
    border-radius: 4px;
    background-color: black;
    font-size: 14px;
    font-weight: 500;
    color: white;
    text-align: center;
}

.second-tool-button {
    padding: 10px 15px;
    border-color: black;
    border: 1px solid black;
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    color: black;
    text-align: center;
}
.hamburger-icon {
    display: none;
    cursor: pointer;
}

/* Media queries for responsiveness */
@media (max-width: 1200px) {
    .button-tool-box {
        margin-right: 20px;
    }
}

@media (max-width: 1000px) {
    .container-tool-head {
        flex-direction: column;
        align-items: flex-start;
      
    }

    .title-tool-box {
        margin-left: 5px;
        margin-top: 30px;
        margin-bottom: 30px;
        /* margin-right: 10px; */
    }

    /* .main-tool-div {
        height: 300px;
    } */

    .button-tool-box {
        display: none;
    }
}
@media (max-width: 800px) {
    .container-tool-head {
        flex-direction: row;
        justify-content: space-between;
    }

    .button-tool-box {
        display: flex;
        gap: 20px;
        margin-right: 70px;
    }

    .hamburger-icon {
        display: block;
        margin-right: 20px;
        font-size: 1.5rem;
    }

    .hidden {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/Toolpage/Header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB,EAAE,2BAA2B;IACnD,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,yDAA6C;IAC7C,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;;;IAGV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IAEvB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA,qCAAqC;AACrC;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;;IAE3B;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;QACnB,wBAAwB;IAC5B;;IAEA;;OAEG;;IAEH;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".container-tool-head {\n    display: flex;\n    flex-direction: column; /* Stack items vertically */\n    justify-content: center;\n    align-items: center;\n    height: 100%; \n    width:100%;\n}\n\n.main-tool-div {\n    /* height: 250px; */\n    min-height: 250px;\n    background-image: url(\"../Images/aiprod.png\");\n    background-size: cover;\n    background-position: center;\n    width:100%;\n    \n    \n    display: flex;\n    flex-direction: column;\n}\n\n.logo-tool-box {\n    padding-top: 20px;\n    /* padding-left: 30px; */\n    max-width: 50px;\n    /* Adjust as per your logo size */\n}\n\n.button-tool-box {\n    display: flex;\n    gap: 20px;\n    margin-right: 70px;\n}\n\n.title-tool-box {\n    font-size: 4rem;\n    font-weight: 600;\n    color: white;\n    margin-top: 50px;\n    margin-left: 0;\n    /* margin-left: 20%; */\n}\n\n.first-tool-button {\n    padding: 10px 15px;\n    border-color: black;\n    border: none;\n    border-radius: 4px;\n    background-color: black;\n    font-size: 14px;\n    font-weight: 500;\n    color: white;\n    text-align: center;\n}\n\n.second-tool-button {\n    padding: 10px 15px;\n    border-color: black;\n    border: 1px solid black;\n    text-align: center;\n    background: transparent;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    color: black;\n    text-align: center;\n}\n.hamburger-icon {\n    display: none;\n    cursor: pointer;\n}\n\n/* Media queries for responsiveness */\n@media (max-width: 1200px) {\n    .button-tool-box {\n        margin-right: 20px;\n    }\n}\n\n@media (max-width: 1000px) {\n    .container-tool-head {\n        flex-direction: column;\n        align-items: flex-start;\n      \n    }\n\n    .title-tool-box {\n        margin-left: 5px;\n        margin-top: 30px;\n        margin-bottom: 30px;\n        /* margin-right: 10px; */\n    }\n\n    /* .main-tool-div {\n        height: 300px;\n    } */\n\n    .button-tool-box {\n        display: none;\n    }\n}\n@media (max-width: 800px) {\n    .container-tool-head {\n        flex-direction: row;\n        justify-content: space-between;\n    }\n\n    .button-tool-box {\n        display: flex;\n        gap: 20px;\n        margin-right: 70px;\n    }\n\n    .hamburger-icon {\n        display: block;\n        margin-right: 20px;\n        font-size: 1.5rem;\n    }\n\n    .hidden {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
